<div style="display: flex;flex-direction: row; margin-top: 30px">
    <div class="display-wrapper">
        <slot name="col-1" />
    </div>
    <div class="sticky-wishlist flex-1">
        <slot name="sticky" />
    </div>
</div>

<style>
    .display-wrapper {
        width: 100%;
    }

    .sticky-wishlist {
        width: 400px;
        font-size: 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    @media screen and (max-width: 700px) {
        .sticky-wishlist {
            display: none;
        }

        .display-wrapper {
            width: 100%;
        }
    }
</style>
